import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';

import { EmbryoLink } from '@/components/common/links';
import { CLINIC_RANCH_HAUL_IN, SEX_EMBRYO } from '@/constants';

export const implantedEmbryoColumDefs: ColDef[] = [
  {
    headerName: '',
    headerTooltip: '',
    width: 10,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    suppressMovable: true,
    lockPosition: true,
  },
  {
    field: 'embryoId',
    headerName: 'Live Embryo',
    width: 110,
    filter: 'agSetColumnFilter',
    valueGetter: (params) => !!params.data?.embryoId,
    cellRenderer: (params: { value: boolean }) => (params.value ? '✓' : '✗'),
  },
  {
    field: 'stateCode',
    headerName: t('common.status'),
    filter: 'agTextColumnFilter',
    width: 100,
    valueFormatter: (params) =>
      params.value === 0 ? 'Active' : params.value === 1 ? 'Inactive' : '',
  },
  {
    field: 'recipient',
    headerName: t('embryo.recipTag'),
    filter: 'agTextColumnFilter',
    width: 120,
  },
  {
    field: 'color',
    headerName: t('common.color'),
    filter: 'agTextColumnFilter',
    width: 80,
  },
  {
    field: 'parity',
    headerName: t('embryo.parity'),
    filter: 'agTextColumnFilter',
    width: 80,
  },
  {
    field: 'straw',
    headerName: t('straw.straw'),
    filter: 'agNumberColumnFilter',
    width: 80,
  },
  {
    field: 'embryoTag',
    headerName: t('embryo.embryoTag'),
    filter: 'agTextColumnFilter',
    width: 120,
  },
  {
    field: 'stage',
    headerName: t('embryo.stage'),
    filter: 'agNumberColumnFilter',
    width: 80,
  },
  {
    field: 'grade',
    headerName: t('embryo.grade'),
    filter: 'agNumberColumnFilter',
    width: 80,
  },
  {
    field: 'sex',
    headerName: t('embryo.sex'),
    filter: 'agSetColumnFilter',
    width: 80,
    valueFormatter: (params) =>
      Object.entries(SEX_EMBRYO).find(
        ([, val]) => val === Number(params.value),
      )?.[0] ?? '',
  },
  {
    field: 'estrusSync',
    headerName: 'Sync',
    filter: 'agTextColumnFilter',
    width: 120,
  },
  {
    field: 'transferQuality',
    headerName: t('transfer.transQuality'),
    filter: 'agNumberColumnFilter',
    width: 110,
  },
  {
    field: 'transDist',
    headerName: 'Trans Dist',
    filter: 'agNumberColumnFilter',
    width: 80,
  },
  {
    field: 'transferTech',
    headerName: 'Transfer Tech',
    filter: 'agNumberColumnFilter',
    width: 80,
  },
  {
    field: 'calfTypeName',
    headerName: 'Implant Type',
    filter: 'agTextColumnFilter',
    width: 80,
  },
  {
    field: 'clValue',
    headerName: t('embryo.cl'),
    filter: 'agTextColumnFilter',
    width: 80,
    valueFormatter: (params) =>
      params.value === 100000000
        ? 'Right'
        : params.value === 100000001
          ? 'Left'
          : (params.value ?? ''),
  },
  {
    field: 'comment',
    headerName: t('common.comment'),
    filter: 'agTextColumnFilter',
    width: 140,
  },
  {
    field: 'siteName',
    headerName: t('embryo.siteName'),
    filter: 'agTextColumnFilter',
    width: 120,
  },
  {
    field: 'ownerName',
    headerName: t('embryo.ownerName'),
    filter: 'agTextColumnFilter',
    width: 120,
  },
  {
    field: 'clinicRanchHaulin',
    headerName: t('embryo.clinicRanchHaulin'),
    filter: 'agNumberColumnFilter',
    width: 130,
    valueFormatter: (params) =>
      Object.entries(CLINIC_RANCH_HAUL_IN).find(
        ([, val]) => val === Number(params.value),
      )?.[0] ?? '',
  },
  {
    field: 'recipientName',
    headerName: 'Recip Name',
    filter: 'agNumberColumnFilter',
    width: 80,
  },
  {
    field: 'embryoName',
    headerName: t('embryo.embryoName'),
    filter: 'agTextColumnFilter',
    width: 120,
    cellRenderer: EmbryoLink,
    cellRendererParams: (params: ICellRendererParams) => ({
      embryoId: params.data?.embryoId as string,
      embryoName: params.data?.embryoName as string,
      openInNewTab: true,
    }),
  },
];
